import { inject, Injectable, signal } from '@angular/core'
import { HttpService } from '@bases/http.service'
import { API_URL } from '@core/constants/constant.data'
import {
  AllModelScenarioDefinition,
  InternalPasswordPayload,
  ScenarioExplorerPayload,
  ScenarioExplorerResult,
} from '@core/models/scenario-tab.model'
import { GeojsonService } from '@core/services/geojson.service'
import { environment } from '@env/environment'
import L from 'leaflet'

@Injectable({
  providedIn: 'root',
})
export class ScenarioService extends HttpService {
  private readonly _geoJsonService = inject(GeojsonService)
  protected _baseUrl = API_URL + '/scenario-explorer'

  models$ = signal<AllModelScenarioDefinition | null>(null)
  scenarioResults$ = signal<ScenarioExplorerResult[]>([])
  isDataLoading$ = signal(false)

  scenarioExplorerPayload$ = signal<ScenarioExplorerPayload>({
    model: '',
    scenario: '',
    variable: '',
    region: '',
    year: '',
    subannual: '',
  })

  layersScenario = new L.FeatureGroup()

  constructor() {
    super()
  }

  async submitInternalScenarioPassword(payload: InternalPasswordPayload) {
    const url = this._baseUrl + '/internal-access'

    const response = await this.POST(payload, url)
    if (response === null) return false
    return response
  }

  getResult(scenarioParameters: ScenarioExplorerPayload): Promise<ScenarioExplorerResult> {
    const payload = { database_name: environment.scenarioExplorer, ...scenarioParameters }
    const url = this._baseUrl + '/result'
    return this.POST(payload, url)
  }

  addLayer(resultToDisplay: ScenarioExplorerResult) {
    const newLayer = this._geoJsonService.buildGeoJSONLayerGroup(resultToDisplay.layer)
    const addedLayer = newLayer.addTo(this.layersScenario)
    const leafletId = L.stamp(addedLayer)
    this.scenarioResults$.update((results) =>
      results.map((result) => {
        if (result == resultToDisplay) {
          return { ...result, isSelected: true, leafletId: leafletId }
        }
        return result
      }),
    )
  }

  removeLayer(resultToRemove: ScenarioExplorerResult) {
    if (resultToRemove.leafletId) {
      const featureGroup = this.layersScenario.getLayer(resultToRemove.leafletId)
      if (featureGroup) {
        this.layersScenario.removeLayer(featureGroup)
        this.scenarioResults$.update((results) =>
          results.map((result) => {
            if (result === resultToRemove) {
              return { ...result, isSelected: false, leafletId: undefined }
            }
            return result
          }),
        )
      }
    }
  }

  addNewLayer(newResult: ScenarioExplorerResult) {
    const newLayer = this._geoJsonService.buildGeoJSONLayerGroup(newResult.layer)
    const addedLayer = newLayer.addTo(this.layersScenario)
    const leafletId = L.stamp(addedLayer)

    this.scenarioResults$.update((previousValue) => {
      return [...previousValue, { ...newResult, isSelected: true, leafletId: leafletId }]
    })
  }
}
